import * as React from 'react';
import { useTheme } from 'styled-components';

interface DotsIconProps {
  noBg?: boolean;
}

export const DotsIcon: React.FC<
  React.SVGProps<SVGSVGElement> & DotsIconProps
> = ({ noBg, ...props }) => {
  const theme = useTheme();

  return (
    <svg viewBox="0 0 32 32" {...props}>
      {!noBg && (
        <path
          fill={theme.colors.differentBackground}
          d="M32,16C32,7.16,24.84,0,16,0S0,7.16,0,16s7.16,16,16,16,16-7.16,16-16Z"
        />
      )}
      <g>
        <circle fill={theme.colors.primary} cx="21" cy="16" r="1" />
        <circle fill={theme.colors.primary} cx="16" cy="16" r="1" />
        <circle fill={theme.colors.primary} cx="11" cy="16" r="1" />
      </g>
    </svg>
  );
};

export default DotsIcon;
